export const getTrending = (videos) =>
  videos.filter((video) => video.isTrending);
